export { default } from "./WithComponentResize";
